import { Component, OnInit } from "@angular/core";
import { SharedService } from "./common/shared.service";
import { TokenEfemeroService } from "./common/url-token";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  showTemplate = false;
  public shared: SharedService;

  constructor(tokenEfemero: TokenEfemeroService) {
    this.shared = SharedService.getInstance();
  }

  ngOnInit() {}
}
